import { buildGetStaticProps } from '../../tngPassthrough/tngPageHandler'

export { default } from '../../tngPassthrough/TngPage'
export { getStaticPaths } from '../../tngPassthrough/tngPageHandler'

export const getStaticProps = buildGetStaticProps('featured', 3600)
